import script from "./LKPage.vue?vue&type=script&setup=true&lang=js"
export * from "./LKPage.vue?vue&type=script&setup=true&lang=js"

import "./LKPage.vue?vue&type=style&index=0&id=0ffc10c8&lang=scss"

const __exports__ = script;

export default __exports__